import clsx from "clsx";
import st from "@/styles/UserSidebar.module.scss";
import {isMobile} from "react-device-detect";
import Images from "@/utils/images.ts";
import CloseBtn from "@/ui/CloseButton.tsx";
import ExitIcon from "@/svg/ExitIcon.tsx";
import React, {ReactNode} from "react";
import {useTranslation} from "react-i18next";
import CommonClass from "@/utils/common.ts";
import {useAtom} from "jotai/index";
import {open_gen_dashboard_menu, open_notifications_sidebar} from "@/atoms/profile.ts";
import DashboardClass from "@/utils/dashboard_class.ts";

import NotificationIcon from "@/svg/NotificationIcon.tsx";
import TranslateIcon from "@/svg/TranslateIcon.tsx";
import QuestionIcon from "@/svg/QuestionIcon.tsx";
import useCommon from "@/hooks/common.ts";
import {useNavigate} from "react-router-dom";
import MultiButton from "@/ui/MultiButton.tsx";
import UserIcon1 from "@/svg/UserIcon1.tsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import KYCProcessingListener from "@/components/KYCProcessingListener.tsx";
import useAuth from "@/hooks/auth.ts";
import {CircularProgress} from "@mui/material";
import useNotifications from "@/hooks/notifications.ts";
import RefreshButton from "@/components/RefreshButton.tsx";

interface Props {
    children: ReactNode
}


interface FooterNavs {
    onCLick?():void,
    icon:ReactNode,
    label: ReactNode | string,
    active: boolean
}

const GeneralMenuOuter:React.FC<Props> = ({children}) => {
    
    const [open, setOpenGenSideMenu] = useAtom(open_gen_dashboard_menu)
    const [openNotifications] = useAtom(open_notifications_sidebar)
    const notif = useNotifications()
    const dc = DashboardClass
    const is_account = location.pathname === dc.dashboard_routes.Account
    const {t, i18n} = useTranslation()
    const user = useAuth().current_user()
    const common_hook = useCommon()
    const navigate = useNavigate();

    const generateNotifnumber = () => {
        let result:any = ""
        
        if(typeof notif.getUnread() === "number"){
            result = notif.getUnread() || "0"

        } else {
            result = <CircularProgress color={"inherit"} size={10} />
            
        }
        
        // notif_list
        if(Number(result) > 9) {
            result = "9+"
        }
        
        return result
    }
    
    
    const footer_navs:Array<FooterNavs> = [
        {
            label: generateNotifnumber(),
            onCLick: () => {
                notif.notification_sidebar_handle()
            },
            icon: <NotificationIcon />,
            active: openNotifications
        },
        
        {
            label:  i18n.language === "ru" ? "RO" : "RU",
            onCLick: () => {common_hook.langToggler()},
            icon: <TranslateIcon />,
            active: false
        },
        
        {
            label: "",
            onCLick: () => {
                window.open(import.meta.env.VITE_WEBSITE_URL+"/terms-and-conditions", "_blank")
            },
            icon: <QuestionIcon />,
            active: false
        }
    ]

    return (
        <div className={clsx(
            st.general_menu,
            isMobile && st.mobile,
            open && st.active
        )}>
            <div className={st.header}>
                <img
                    onClick={() => {
                        navigate(DashboardClass.dashboard_routes.Home)
                    }}
                    style={{
                        height: "auto"
                    }}
                    src={Images.logos.LogoSimple}
                    alt={"logo"}
                    width={91}
                />

                <CloseBtn onClick={() => {
                    setOpenGenSideMenu(false)
                }} className={st.close_btn}/>
            </div>
            
            
            <KYCProcessingListener />
            
            {children}
            
            <div className={st.footer}>
                {!isMobile && (
                    <RefreshButton gray isMobile />
                )}

                <div className={st.footer_multi_button}>

                    {footer_navs.map((f_nav: FooterNavs, i) => {

                        const {
                            icon,
                            onCLick,
                            label,
                            active
                        } = f_nav

                        return (
                            <button
                                onClick={onCLick}
                                key={`f_nav_${i}`}
                                className={clsx(st.simple_btn, active && st.active)}
                            >
                                {icon}

                                {(typeof label === "string" && Boolean(label.length)) ? (
                                    <span className={st.label}>
                                        {label}
                                    </span>
                                ) : label}

                            </button>
                        )
                    })}
                
                </div>
                
                
                <MultiButton
                    icon_left={<UserIcon1 />}
                    icon_right={<ExitIcon />}
                    active={is_account}
                    left_text={t("account")}
                    red_badge_text={(user?.kyc_general_status !== "ProcessingSuccess" && user?.auth_type !== "ByMPass") ? t("unverified1") : undefined}
                    gray_right
                    left_function={() => {
                        navigate(dc.dashboard_routes.Account)
                    }}
                    right_function={() => {
                        eventEmitter.emit(CommonClass.CustomEvents.logout)
                    }}
                />
            
            </div>
        
        </div>
    )
}

export default GeneralMenuOuter